<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { t } from '../i18n';
import { download } from '../export';

/** Shows the raw stored data of an object — the way to get data of unavailable objects (§7.5). */
const props = defineProps<{ json: string }>();
const emit = defineEmits<{ close: [] }>();
const box = ref<HTMLTextAreaElement | null>(null);

onMounted(() => box.value?.focus());

async function copy(): Promise<void> {
  try {
    await navigator.clipboard.writeText(props.json);
  } catch {
    box.value?.select();
  }
}

function save(): void {
  download(new Blob([props.json], { type: 'application/json' }), 'object.json');
}
</script>

<template>
  <div class="dialog-backdrop" @click.self="emit('close')" @keydown.esc="emit('close')">
    <div class="dialog" role="dialog" aria-modal="true" :aria-label="t('cmd.showData')">
      <h3>{{ t('cmd.showData') }}</h3>
      <textarea ref="box" class="input data" readonly :value="json"></textarea>
      <div class="actions">
        <button class="btn" @click="copy">{{ t('common.copy') }}</button>
        <button class="btn" @click="save">{{ t('common.download') }}</button>
        <button class="btn primary" @click="emit('close')">{{ t('common.close') }}</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.data {
  width: 100%;
  height: 360px;
  font-family: ui-monospace, 'Cascadia Code', Consolas, monospace;
  font-size: 12px;
}
</style>
